import { ExtensionInfo } from 'hooks/embedded-status/useEmbeddedStatusSwr';
import { useTranslation } from 'react-i18next';
import { SettingsWrapper } from '../../../settings-wrapper/SettingsWrapper';
import { hasBlockEmbed } from '../../integrationStatusUtils';

export const BlockEmbedIntegration = ({
    themeAppExtension,
    isLoading,
    condensed,
    handleClickAddStoreAppBlock,
}: BlockEmbedIntegrationProps) => {
    const { t } = useTranslation();

    const hasPickupAppBlock = hasBlockEmbed(themeAppExtension);

    const handleAddStoreAppBlock = () => {
        open(
            `shopify://admin/themes/current/editor?template=cart&addAppBlockId=${
                import.meta.env.VITE_APP_CLIENT_ID
            }/pickup-app-block&target=newAppsSection`,
            '_blank'
        );
        handleClickAddStoreAppBlock?.();
    };

    const previewStoreAppBlock = () => {
        open(`shopify://admin/themes/current/editor?template=cart`, '_blank');
    };

    return (
        <SettingsWrapper
            title={t('DASHBOARD.APP_EXTENSIONS.BLOCK_EMBED_INTEGRATION.TITLE')}
            badge={
                <s-badge tone={hasPickupAppBlock ? 'success' : undefined}>
                    {hasPickupAppBlock ? t('DASHBOARD.APP_EXTENSIONS.ACTIVE') : t('DASHBOARD.APP_EXTENSIONS.INACTIVE')}
                </s-badge>
            }
            description={
                hasPickupAppBlock
                    ? t('DASHBOARD.APP_EXTENSIONS.BLOCK_EMBED_INTEGRATION.ACTIVE')
                    : t('DASHBOARD.APP_EXTENSIONS.BLOCK_EMBED_INTEGRATION.INACTIVE')
            }
            actions={
                <s-button
                    variant="secondary"
                    onClick={hasPickupAppBlock ? previewStoreAppBlock : handleAddStoreAppBlock}
                >
                    {hasPickupAppBlock
                        ? t('DASHBOARD.APP_EXTENSIONS.BLOCK_EMBED_INTEGRATION.ACTIONS.BLOCK_SETTINGS')
                        : t('DASHBOARD.APP_EXTENSIONS.BLOCK_EMBED_INTEGRATION.ACTIONS.ADD_BLOCK')}
                </s-button>
            }
            isLoading={isLoading}
            condensed={condensed}
        />
    );
};

interface BlockEmbedIntegrationProps {
    themeAppExtension: ExtensionInfo;
    isLoading: boolean;
    condensed?: boolean;
    handleClickAddStoreAppBlock?: () => void;
}
